import type { IssuanceProductionDataCountryMetadata } from "@/dashboard/production_strategy/issuance-reporting/useIssuanceProductionDataStore";
import {
  normalizeFlags,
  type PlCountryMetadata,
  type PlIssuanceMetadataUpdate,
} from "../plStatusUtils";

export const mergeCountryMetadata = (
  countryMetadata: IssuanceProductionDataCountryMetadata | undefined,
  plUpdate: PlIssuanceMetadataUpdate
): IssuanceProductionDataCountryMetadata => {
  const currentMetadata = countryMetadata ?? {};
  const currentPlMetadata =
    (currentMetadata.PL as PlCountryMetadata | undefined) ?? {};

  const mergedFlags = normalizeFlags({
    ...currentPlMetadata.pl_issuance_flags,
    ...plUpdate.pl_issuance_flags,
  });

  const nextPlMetadata: PlCountryMetadata = {
    ...currentPlMetadata,
    pl_issuance_flags: mergedFlags,
    ...(plUpdate.pl_issuance_status !== undefined && {
      pl_issuance_status: plUpdate.pl_issuance_status ?? null,
    }),
  };

  return {
    ...currentMetadata,
    PL: nextPlMetadata,
  };
};
